import React from 'react';

/**
 * Spinner loader (replaces caribe7/modules/base/parts/Spinner).
 */
export default function Spinner({ cover = false }: { cover?: boolean }) {
  return (
    <div
      className={`col-lg-12 d-flex justify-content-center spinner-wrapper ${cover ? 'covered' : ''}`}
    >
      <div className="spinner-border" role="status">
        <span className="sr-only" />
      </div>
    </div>
  );
}
